import React, { useEffect, useState } from "react";
import "./style.css";
import { DashboardApis } from '../../apis/DashboardApis'
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";


export default function Dashboard() {

  const [leads, setLeads] = useState([]);
  const [page, setPage] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [limit, _setLimit] = useState(10)
  const [totalpage, setTotalPage] = useState(10)
  // eslint-disable-next-line no-unused-vars
  const [filter, setFilter] = useState('')
  const [availableFilters, setAvailableFilters] = useState([])
  const history = useHistory()

  useEffect(() => {
    DashboardApis.filters().then(response => {
      setAvailableFilters(response.data.filters || [])
    }).catch(error => {
      console.log(error.status)
      if (error.status === 401) {
        localStorage.removeItem('token')
        history.push('/login')
      }
      console.error("Error fetching filter options:", error);
    })
  }, [history])

  useEffect(() => {
    // Fetch dashboard data here
    DashboardApis.listAll(page, limit, filter).then(response => {

      setLeads(response.data.leads);
      setTotalPage(+response.data.pagination.totalPages)
    }).catch(error => {
      console.log(error.status)
      if (error.status === 401) {
        localStorage.removeItem('token')
        history.push('/login')
      }
      console.error("Error fetching leads data:", error);
    })
  }, [page, limit, history, filter]);


  const downloadExcel = () => {
    DashboardApis.export(filter).then(response => {
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'data.xlsx'; // Suggest a filename
      document.body.appendChild(link);
      link.click(); // Programmatically click the link

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    })
  }


  const handleNext = () => {
    if (page < totalpage) {
      setPage(page + 1)
    }
  }

  const handlePrev = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleSelectChange = (e) => {
    e.preventDefault()
    setPage(1)
    setFilter(e.target.value)
  }

  const reset = () => {
    setFilter('')
    setPage(1)
  }


  return (
    <div className="app-layout">

      {/* Content */}
      <main >
        <div className="dashboard-header">
          <h1>
            Dashboard
          </h1>
          <div>
            <Link
              to="/form?action=add"
              className="dashboard-header-link"
            >Add Lead</Link>
            <button className="dashboard-header-link"
              onClick={() => downloadExcel()}
            >
              Download Excel
            </button>
          </div>
        </div>

        <div className="filter-section">
          <div className="filter">
            <label>Filter By</label>
            <select value={filter} onChange={(e) => handleSelectChange(e)}>
              <option value="">All Pages</option>
              {availableFilters.map((f) => (
                <option key={f.value} value={f.value}>
                  {f.label}
                </option>
              ))}
            </select>
          </div>

          <button className="btn" onClick={reset}>
            Reset
          </button>
        </div>

        <div className="dashboard-section">
          <div className="dashboard-section-title">Leads</div>

          <table className="dashboard-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Organization</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Message</th>
                <th>Page</th>
                <th>Form Title</th>
                <th>Created At</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {leads.map((lead, index) => (
                <tr key={index}>
                  {/* <td>{lead.id}</td> */}
                  <td>{lead.name}</td>
                  <td>{lead.designation}</td>
                  <td>{lead.organization}</td>
                  <td>{lead.mobile}</td>
                  <td>{lead.email}</td>
                  <td>{lead.message || 'NA'}</td>
                  <td>{lead.page}</td>
                  <td>{lead.form_title}</td>
                  <td>{lead.formatted_date}</td>
                  {/* <td>
                    <Link
                      to={`/form/${lead.id}?action=update`}
                    >Update</Link>
                    <button onClick={() => handleDelete(lead.id)} className="action-link">Delete</button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div>
          <span style={{ marginRight: '1rem' }}>
            Page {page} of {totalpage}
          </span>
          <button
            className="btn"
            onClick={handlePrev}
            disabled={page === 1}
          >
            Prev
          </button>
          <button
            className="btn"
            onClick={handleNext}
            disabled={page === totalpage || totalpage === 0}
          >
            Next
          </button>
        </div>
      </main>
    </div>
  );
}
